import React, { useState } from "react";

const servicesData = [
  {
    id: "web",
    title: "Web & Digital Ecosystems",
    shortDesc: "We don't just build websites, we build high-performing digital tools designed to scale.",
    popupTitle: "Web & Digital Ecosystems",
    popupDesc: "Centralize your operations with a single source of truth.",
    bullets: [
      "Custom website & web app development",
      "Enterprise Resource Planning (ERP)",
      "CMS integration (WordPress, headless CMS, etc.)",
      "eCommerce solutions (Shopify, custom solutions)",
      "Website maintenance and support",
    ],
    bgClass: "bg-gray-100",
  },
  {
    id: "mobile",
    title: "Mobile & Desktop Applications",
    shortDesc: "Native and cross-platform application that put your business in the palm of your customer's hand.",
    popupTitle: "Mobile & Desktop Applications",
    popupDesc: "Take your business anywhere with cutting-edge app development. We build intuitive, high-performing applications.",
    bullets: [
      "Android and iOS app development",
      "Desktop application development (Windows, macOS)",
      "Cross-platform development (React Native, Flutter)",
      "UI/UX design for mobile & desktop apps",
      "App maintenance and updates",
    ],
    bgClass: "bg-gray-200",
  },
  {
    id: "ai",
    title: "AI & Intelligent Automation",
    shortDesc: "Future-proof your workflow with custom Artificial Intelligence for smarter decisions.",
    popupTitle: "AI & Intelligent Automation",
    popupDesc: "Harness the power of AI to automate tasks, improve decision-making, and unlock new business opportunities.",
    bullets: [
      "Custom Machine Learning models",
      "Process automation and optimization",
      "Predictive analytics and data insights",
      "Natural Language Processing (NLP) solutions",
      "AI integration with existing software",
    ],
    bgClass: "bg-gray-100",
  },
  {
    id: "iot",
    title: "Embedded Systems & IoT Solutions",
    shortDesc: "Bridging the physical and digital worlds to save you time, effort, and capital.",
    popupTitle: "Embedded Systems & IoT Solutions",
    popupDesc: "Connect and control hardware with intelligent software. We design robust embedded systems and IoT infrastructure.",
    bullets: [
      "IoT device integration and management",
      "Custom embedded software development",
      "Hardware-software interfacing",
      "Real-time monitoring and control systems",
      "Smart sensors and data collection",
    ],
    bgClass: "bg-gray-200",
  },
  {
    id: "erp",
    title: "Enterprise Resource Planning (ERP)",
    shortDesc: "Centralize your operations and streamline your business processes with a unified ERP system.",
    popupTitle: "Enterprise Resource Planning (ERP)",
    popupDesc: "Manage all your core business processes in one place. We build and integrate custom ERP solutions tailored to your workflow.",
    bullets: [
      "Custom ERP software development",
      "Integration with existing tools (CRM, accounting, HR)",
      "Supply chain and inventory management",
      "Data migration and cloud hosting",
      "Workflow automation and reporting",
    ],
    bgClass: "bg-gray-100",
  },
  {
    id: "maintenance",
    title: "Maintenance & Support",
    shortDesc: "Reliable ongoing support to keep your digital infrastructure secure, updated, and performing at its best.",
    popupTitle: "Maintenance & Support",
    popupDesc: "We provide comprehensive maintenance packages so you never have to worry about downtime or outdated software.",
    bullets: [
      "24/7 technical support and troubleshooting",
      "Security patching and vulnerability monitoring",
      "Performance optimization and scaling",
      "Regular software and server updates",
      "Data backup and disaster recovery",
    ],
    bgClass: "bg-gray-200",
  },
];

const ServicesPage = () => {
  const [activeService, setActiveService] = useState(null);

  const handleClosePopup = () => {
    setActiveService(null);
  };

  return (
    <>
      {/* Banner Section */}
      <div
        className="bg-cover bg-center h-96 flex items-center justify-center text-white relative"
        style={{
          backgroundImage: `url("https://images.unsplash.com/photo-1531973576160-7125cd663d86?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Mnx8SVQlMjBjb21wYW55fGVufDB8fDB8fHww")`,
        }}
      >
        <div className="absolute top-0 h-96 inset-0 bg-black bg-opacity-50"></div>
        <h1 className="text-4xl font-bold relative z-10">Service We Provide</h1>
      </div>

      {/* Services Section */}
      <div className="p-8 grid grid-cols-1 md:grid-cols-2 gap-8 max-w-7xl mx-auto">
        {servicesData.map((service) => (
          <div key={service.id} className={`${service.bgClass} p-8 rounded-lg shadow-lg`}>
            <h2 className="text-2xl font-semibold mb-4">{service.title}</h2>
            <p className="mb-4 text-gray-800">{service.shortDesc}</p>
            <button
              onClick={() => setActiveService(service)}
              className="px-4 py-2 bg-gray-800 text-white rounded hover:bg-gray-700 transition"
            >
              More &rarr;
            </button>
          </div>
        ))}
      </div>

      {/* Dynamic Popup */}
      {activeService && (
        <div className="fixed inset-0 bg-gray-900 bg-opacity-75 flex justify-center items-center z-50 p-4">
          <div className="bg-white p-8 rounded-lg shadow-lg max-w-lg w-full space-y-4 overflow-y-auto max-h-full">
            <h2 className="text-2xl font-bold">{activeService.popupTitle}</h2>
            <p className="text-gray-700">{activeService.popupDesc}</p>
            <ul className="list-disc pl-5 space-y-2 text-gray-800">
              {activeService.bullets.map((bullet, index) => (
                <li key={index}>{bullet}</li>
              ))}
            </ul>
            <div className="pt-4">
              <button
                onClick={handleClosePopup}
                className="px-4 py-2 bg-gray-800 text-white rounded hover:bg-gray-700 transition"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ServicesPage;
